import axios from "axios";
import { identity, both, pathEq } from "ramda";
import store from "@/store";
import router from "@/router";
const baseURL = `${process.env.VUE_APP_API_BASE_URL}`;
const _axios = axios.create({ baseURL });

_axios.addBearerToken = function(firebaseUserToken) {
  this.defaults.headers.common = {
    Authorization: `Bearer ${firebaseUserToken}`,
  };
};

_axios.clearBearerToken = function() {
  this.defaults.headers.common = {};
};

const isSessionExpireError = both(
  pathEq(["request", "status"], 401),
  pathEq(["response", "data", "detail"], "Session expired")
);

const refreshSessionToken = async (refresh_token, session_token) => {
  const data = { refresh_token };
  const headers = { "x-session-token": session_token };
  return axios.post(process.env.VUE_APP_ELSA_USER_SERVER + "/user/api/v1/account/refresh-session", data, { headers });
};

_axios.interceptors.response.use(identity, async function(error) {
  if (error && error.response && error.response.status && error.response.status === 401 && !error.config.retried) {
    error.config.retried = true;
    const refreshToken = localStorage.getItem("refresh-token") || "";
    const sessionToken = localStorage.getItem("payment-token") || "";
    if (refreshToken && sessionToken) {
      try {
        const res = await refreshSessionToken(refreshToken, sessionToken);
        if (res.data) {
          localStorage.setItem("payment-token", res.data.session);
          localStorage.setItem("refresh-token", res.data.refresh_token);

          error.config.headers = {
            "x-session-token": res.data.session,
          };
        }
      } catch (error) {
        store.dispatch("auth/sessionExpired");
        router.push({ name: "Login" });
      }
    }
    const dataReq = typeof error.config.data === "string" ? JSON.parse(error.config.data) : error.config.data;
    return _axios({ ...error.config, data: dataReq });
  }
  const orgApiRegex = /^\/v1\/organizations\/[^/]+\/?$/;
  let path = error.config.url;
  if (!path.startsWith('/')) path = '/' + path;
  if (error && error.response && error.response.status && error.response.status === 403 && error.config &&
    error.config.url && orgApiRegex.test(path)) {
    router.push({ name: "prohibited", query: { reason: "organization-permission" } });
  }

  const originalConfig = error.config;
  // Do something with response error
  if (isSessionExpireError(error) && !originalConfig._retry) {
    originalConfig._retry = true;
    return store
      .dispatch("auth/refreshToken")
      .then(async newUserToken => {
        error.config.headers = {
          Authorization: `Bearer ${newUserToken}`,
        };
        return _axios(error.config);
      })
      .catch(er => {
        return Promise.reject(er);
      });
  }
  return Promise.reject(error);
});

export default _axios;
